import {
  CHECKOUT_PAGE,
  
} from "../Constants/AppConstants";

export const appReducer = (
  state = { isCheckoutPage:false },
  action
) => {
  switch (action.type) {
    case CHECKOUT_PAGE:
      const item = action.payload;
      
      return {
        ...state,
        isCheckoutPage: item,
      };

   
    default:
      return state;
  }
};
